import { MutationHookOptions, useMutation } from '@apollo/client';
import gql from 'graphql-tag';

const INCREMENT_USER_POINT_MUTATION = gql`
  mutation incrementUserPoint($points: Int!) {
    incrementUserPoint(points: $points)
  }
`;

export interface IncrementUserPointMutationType {
  incrementUserPoint: boolean;
}

export interface IncrementUserPointVariables {
  points: number;
}

export function useIncrementUserPointMutation(
  options?: MutationHookOptions<IncrementUserPointMutationType, IncrementUserPointVariables>,
) {
  return useMutation<IncrementUserPointMutationType, IncrementUserPointVariables>(
    INCREMENT_USER_POINT_MUTATION,
    options,
  );
}
